<template>
  <li :class="item.cssClass">
    <a href="#" @click.prevent="$emit('click:menuItem', item)">
      <div class="flex-column">
        <div class="menu_title bold">{{ $_translations.value[item.title] }}</div>

        <div v-if="item.description" class="menu_desc">
          {{ $_translations.value[item.description] }}
        </div>
      </div>

      <i class="fas fa-chevron-right"></i>
    </a>
  </li>
</template>

<script setup>
defineEmits(['click:menuItem']);

defineProps({
  item: {
    type: Object,
    default: () => ({
      id: '',
      title: '',
      description: '',
      routeName: '',
      cssClass: '',
    }),
  },
});
</script>
